module.exports = __webpack_public_path__ + "e7fea7c4bd082d1d8c52ce5b74ffa27b.MP3";